'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiMessages = function TiMessages(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 11.7h-5c0-2.8-2.2-5-5-5h-20c-2.7 0-5 2.2-5 5v11.6c0 2.8 2.3 5 5 5v5l5-5c0 2.8 2.3 5 5 5h13.3l5 5v-5h1.7c2.8 0 5-2.2 5-5v-11.6c0-2.8-2.2-5-5-5z m-30 13.3c-0.9 0-1.7-0.8-1.7-1.7v-11.6c0-0.9 0.8-1.7 1.7-1.7h20c0.9 0 1.7 0.8 1.7 1.7v1.6h-10.9c-2.3 0-4.1 1.9-4.1 4.2v7.5h-6.7z m31.7 3.3c0 0.9-0.8 1.7-1.7 1.7h-20c-0.9 0-1.7-0.8-1.7-1.7v-10.8c0-1.4 1.2-2.5 2.5-2.5h19.2c0.9 0 1.7 0.8 1.7 1.7v11.6z' })
        )
    );
};

exports.default = TiMessages;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/messages.js
// module id = 3904
// module chunks = 0